import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InvestmentsAccessResponse, fetchInvestmentsAccessStatus } from "@features/investments/api";

export const investmentsAccessQueryKey = ["investments", "access"] as const;

export function useInvestmentsAccessQuery(): UseQueryResult<InvestmentsAccessResponse, Error> {
  return useQuery({
    queryKey: investmentsAccessQueryKey,
    queryFn: fetchInvestmentsAccessStatus,
    retry: false,
  });
}
